import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8vajze9chy: FaireBrandEntity = {
  token: "b_8vajze9chy",
  type: "brand",
  name: "The Bomb Bar",
  avatarUrl:
    "https://cdn.faire.com/fastly/1a7eb554ecdaf48a284694d33c464c2a89e317495e49a2db93d7e83da2929740.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d4ae56f3616a2f07acebb7e3a45f2f11d9eb1e055b72aa8c6715a7f5f460cf62.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/1a7eb554ecdaf48a284694d33c464c2a89e317495e49a2db93d7e83da2929740.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d4ae56f3616a2f07acebb7e3a45f2f11d9eb1e055b72aa8c6715a7f5f460cf62.jpeg",
  location: "Lethbridge, AB, CAN",
  minimumOrderDollars: 200,
  rating: 5,
  reviewCount: 179,
  isTopShop: true,
  isInsider: false,
  description:
    "The Bomb Bar®'s bath bombs are locally made in Canada and completely hand-crafted with sustainably sourced ingredients. Our products include unique fun-shaped bath bombs, themed bath bombs, shower steamers, bubble bath soaks, and salts. ",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:09.741Z",
    importedBy: "entity-db-cli",
  },
};
